import React, { useState } from 'react';
import { ChatMessages } from '../components/ChatMessages';
import { ChatInput } from '../components/ChatInput';
import { sendMessage } from '../services/api';
import type { Message } from '../types';
import { MessageCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

function Chat() {
  const [messages, setMessages] = useState<Message[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { currentUser } = useAuth();

  const handleSendMessage = async (text: string, audioBlob?: Blob) => {
    try {
      setIsLoading(true);
      
      // Create a new user message
      const userMessage: Message = { 
        type: 'user', 
        message: text,
        audioBlob 
      };
      setMessages(prev => [...prev, userMessage]);

      // Get feedback from teacher endpoint
      const feedbackData = await sendMessage('teacher', text, messages, currentUser);
      
      // Update the user message with feedback
      setMessages(prev => prev.map(msg => 
        msg === userMessage 
          ? { ...msg, feedback: feedbackData? feedbackData.message : '' }
          : msg
      ));

      // Get bot response
      const botData = await sendMessage('talk', text, messages, currentUser);
      setMessages(prev => [...prev, { type: 'bot', message: botData.message }]);
    } catch (error) {
      console.error('Error:', error);
      setMessages(prev => [
        ...prev,
        { type: 'bot', message: 'Sorry, there was an error processing your message.' }
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-screen bg-gradient-to-br from-purple-50 to-white">
  {/* Header */}
  <header className="text-center py-8">
    <div className="flex items-center justify-center gap-3 mb-4">
      <MessageCircle className="w-12 h-12 text-purple-600" />
      <h1 className="text-4xl font-bold text-gray-900">AI Chat</h1>
    </div>
    <p className="text-lg text-gray-600 max-w-2xl mx-auto px-4">
      Talk with our AI teacher and get instant feedback on your words.
    </p>
  </header>

  {/* Scrollable content */}
  <main className="flex-grow flex flex-col items-center justify-center w-full lg:w-[40%] mx-auto px-4">
    <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 p-6 rounded-xl shadow-sm w-full text-center flex flex-col items-center gap-3">
      <div className="w-12 h-12 bg-yellow-100 text-yellow-600 rounded-full flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h3 className="font-bold text-lg">Under Development Improvements</h3>
      <p className="text-sm text-yellow-700">Esta funcionalidade está temporariamente desativada para melhorias.</p>
    </div>
  </main>
</div>
  );
}

export default Chat;